<div class="se-contextmenu mat-elevation-z3" [ngStyle]="{'left.px': x, 'top.px': y}" [class.opened]="isOpen" (clickOutside)="onClickOutside()">
  <ng-content></ng-content>
</div>
